import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  pending: false,
  list: [],
  groups: {}
});

export function setList(state, list) {
  return state.merge({ list });
}

export function setListByGroup(state, groupId, list) {
  const groups = state.getIn(['groups']).toJS();
  groups[groupId] = list;
  return state.merge({ groups });
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CUSTOMERS_PENDING':
      return setPendingSelf(state, action.pending);

    case 'CUSTOMERS_LIST':
      return setList(state, action.list);

    case 'CUSTOMERS_LIST_BY_GROUP':
      return setListByGroup(state, action.groupId, action.list);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/customers.js